import { FC } from 'react';

import Skeleton from 'react-loading-skeleton';

import { useMerchants } from '@entities/merchant';
import ErrorMessage from '@shared/components/ErrorMessage';
import { ISelectMultiOptions, SelectMulti } from '@shared/components/Form';

import 'react-loading-skeleton/dist/skeleton.css';

interface IProps {
  onChangeMerchants?: (selectedMerchantsOptions: ISelectMultiOptions) => void;
}

export const MerchantsMultiSelect: FC<IProps> = ({ onChangeMerchants }) => {
  const { merchants, isLoading, isFetching, error } = useMerchants({ disableUrlFilter: true });

  if (isLoading) return <Skeleton height={42} />;
  if (error) {
    return (
      <>
        <select></select>
        <ErrorMessage error={error} />
      </>
    );
  }

  if (merchants) {
    const merchantOptions = merchants.data.map(merchant => ({
      value: merchant.id,
      label: merchant.short_name,
    }));

    return (
      <SelectMulti
        name='merchant_id'
        options={merchantOptions}
        onChange={onChangeMerchants}
        isDisabled={isFetching}
      />
    );
  }

  return null;
};
